var React = require('react');

function ProductsIcon32Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_48","data-name":"Obszar roboczy 48","transform":"translate(-5.84 -6.48)"},[React.createElement("path",{"id":"Path_372","data-name":"Path 372","d":"M9.94,15.38l3.05,6.85h2.67L12.6,15.38Z","key":0}),React.createElement("path",{"id":"Path_373","data-name":"Path 373","d":"M18.26,22.23,25.61,6.48h-2.6L15.66,22.23Z","key":1}),React.createElement("path",{"id":"Path_374","data-name":"Path 374","d":"M32.86,31.86l-7.84-7.84a10.675,10.675,0,0,0,2.32-6.65A10.842,10.842,0,0,0,25.91,12l-2.18,1.26a8.239,8.239,0,1,1-7.14-4.13,8.067,8.067,0,0,1,2.88.52l.88-2.36a10.75,10.75,0,1,0-3.76,20.82,10.616,10.616,0,0,0,6.55-2.25l7.85,7.85,1.87-1.87Z","key":2})]));
}

ProductsIcon32Inline.defaultProps = {"width":"27.02","height":"27.23","viewBox":"0 0 27.02 27.23"};

module.exports = ProductsIcon32Inline;

ProductsIcon32Inline.default = ProductsIcon32Inline;
